import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { MapPin, Phone, Mail } from 'lucide-react';
import { mockData } from '../mock';

const ContactSection = () => {
  const { restaurant } = mockData;

  const handleEmail = () => {
    window.location.href = `mailto:${restaurant.email}`;
  };

  return (
    <section id="contact" className="section-padding bg-warm-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-serif font-bold text-dark mb-4">
            Contact
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Contactez-nous pour plus d'informations
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {/* Contact Info */}
          <Card className="card-hover border-2 border-gray-100">

            <CardContent className="p-8 space-y-6">
              <div className="flex items-start space-x-4">
                <MapPin className="h-6 w-6 text-primary mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold text-gray-800 mb-1">Adresse</h3>
                  <p className="text-gray-600">{restaurant.address}</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <Phone className="h-6 w-6 text-primary mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold text-gray-800 mb-1">Téléphone</h3>
                  <p className="text-gray-600">{restaurant.phone}</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <Mail className="h-6 w-6 text-primary mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold text-gray-800 mb-1">Email</h3>
                  <p className="text-gray-600">{restaurant.email}</p>
                </div>
              </div>

              <div className="pt-6 border-t border-gray-100">
                <div className="bg-warm-white rounded-lg p-4 text-center">
                  <p className="text-gray-700 font-medium mb-2">
                    Table d’hôtes sur réservation uniquement.<br />
                  </p>
                  <p className="text-sm text-gray-600">
                    Minimum&nbsp;: 8&nbsp;personnes.<br />
                    Privatisation dès 20&nbsp;personnes (max.&nbsp;25).<br />
                    Service en mange-debout possible jusqu’à 50&nbsp;convives.<br />
                    Merci de nous contacter pour réserver votre table
                  </p>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <Button
                  className="btn-messenger flex-1"
                  onClick={() => window.open("https://m.me/camie.piraprez", "_blank")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    className="mr-2"
                  >
                    <path d="M12 0C5.373 0 0 4.932 0 11c0 3.455 1.748 6.53 4.548 8.54V24l4.163-2.28C9.313 22.01 10.628 22.2 12 22.2c6.627 0 12-4.932 12-11S18.627 0 12 0zm1.13 14.958l-2.854-3.05-5.184 3.05 5.728-6.05 2.854 3.05 5.184-3.05-5.728 6.05z" />
                  </svg>
                  Contacter le Chef
                </Button>

                <Button className="btn-secondary flex-1" onClick={handleEmail}>
                  Envoyer un email
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
        {/* Carte Google Maps */}
        <div className="mt-12">
          <Card className="border-2 border-gray-100">
            <CardContent className="p-0">
              <div className="aspect-[21/9]">
                <iframe
                  title="Carte Au 4A"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2535.504704092467!2d5.222210577401578!3d50.54338357161008!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c1a9c7bba60707%3A0x21c59a1bf46a72a6!2sRue%20Grandes%20Ruelles%204A%2C%204520%20Wanze!5e0!3m2!1sfr!2sbe!4v1753467753315!5m2!1sfr!2sbe"
                  className="w-full h-full rounded-lg border-0"
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;